export function CollapsedSection({ title, onClick, status }) {
  return (
    <div className="dashboard-section">
      <div className="dashboard-section-title">
        <div
          className="opt-table-title opt-table-title-dash-stats"
          style={{
            margin: 0,
            border: 0,
            padding: 0,
            justifyContent: "flex-start",
          }}
        >
          {title}
          <button className="cell-icon" onClick={onClick}>
            <img
              src={
                status
                  ? "/images/arrow-up-blue.svg"
                  : "/images/arrow-down-blue.svg"
              }
              loading="lazy"
              alt="Icon"
              className="cell-icon"
            ></img>
          </button>
        </div>
      </div>
    </div>
  );
}
